
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-faculty-list",
      function () {
        return require("private-next-pages/tnpsc-faculty-list/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-faculty-list"])
      });
    }
  